<template>
    <div v-if="movimentacao.Lancamentos.length > 0">
        <p class="text-center"><strong>{{ title }}</strong></p>
        
        <div class="responsive-table">
            <table class="table-movimentacao">
                <thead>
                    <th width="90">Data</th>
                    <th align="left">Histórico</th>
                    <th align="right" width="95">Débito</th>
                    <th align="right" width="95">Crédito</th>
                    <th align="right" width="95">Saldo</th>
                    <!--<th width="30"></th>-->
                </thead>
                <tbody>
                    <Lancamento v-for="lancamento in movimentacao.Lancamentos" :key="lancamento.id" :filtro_lancamentos="filtro_lancamentos" :lancamento="lancamento" :previsao="false"></Lancamento>
                    <tr>
                        <td colspan="2" align="right"><strong>Total</strong></td>
                        <td align="right"><strong v-raw class="text-red">{{ -movimentacao.SubTotal.ValorDebito | number_format }}</strong></td>
                        <td align="right"><strong v-raw class="text-green">{{ movimentacao.SubTotal.ValorCredito | number_format }}</strong></td>
                        <td align="right">
                            <strong v-if="filtro_lancamentos == ''" v-raw :class="movimentacao.SubTotal.ValorAtual < 0 ? 'text-red' : 'text-green'">{{ movimentacao.SubTotal.ValorAtual | number_format }}</strong>
                        </td>
                        <!--<td></td>-->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import Lancamento from './lancamento.vue';
export default {
    props: ["movimentacao", "title", 'filtro_lancamentos'],
    components: {
        Lancamento
    },
    filters: {
        number_format(value) {
            let sign = '';
            if (value < 0) {
                sign = '<b class="number-sign">-</b>'
            }
            let str = sign  + new Intl.NumberFormat("pt-BR", {
                currencySign: 'accounting',
                //currencySign: 'standard',
                style: "decimal",
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Math.abs(value));

            return str;
        },
    },
}
</script>
<style scoped>
    tr.saldo-dia td {
        font-weight: bold;
    }
</style>